import { useContext } from 'react';
import { ActiveCondominioContext } from '../context/ActiveCondominioContext';

/**
 * useActiveCondominio - Hook para consumir contexto de condomínio ativo
 * 
 * Retorna:
 * - activeCondominio: string | null
 * - setActiveCondominio: (novoId) => void
 * - condominios: array
 * - loading: boolean
 */
const useActiveCondominio = () => {
  const context = useContext(ActiveCondominioContext);

  if (!context) {
    const errorMessage =
      '❌ useActiveCondominio deve ser usado dentro de ActiveCondominioProvider. ' +
      'Verifique se o Provider está envolvendo o componente.';
    console.error(errorMessage);
    throw new Error(errorMessage);
  }

  return context;
};

export default useActiveCondominio;
